import { Cookie as CookieNames } from '@ps/web-core-store';
import classNames from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cookies from 'universal-cookie';
import URL from 'url-parse';

import { CMSReference } from '@swf/cms';
import type { ReferAFriend } from '@swf/cms';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import type { TranslationTag } from '@swf/core/types/i18n';
import type { GlobalFieldReference } from '@swf/generated/cms/types/GlobalFields';

import {
  TXTCLI_Copy_link,
  TXTCLI_Failed_to_copy_linkX,
  TXTCLI_Link_copiedX,
  TXTCLI_Login,
  TXTCLI_Your_referral_link
} from './CMSReferAFriend.messages.json';
import styles from './CMSReferAFriend.scss';

const cookies = new Cookies();
const getBackgroundImageStyle = (isMobile: boolean, url?: string) =>
  url && !isMobile ? { backgroundImage: `url(${url})`, backgroundSize: 'cover', padding: 20 } : {};

const CMSReferAFriend: React.FC<ReferAFriend> = ({
  background_image: backgroundImage,
  base_url: baseUrl,
  logged_in_body: loggedInBody = [],
  logged_out_body: loggedOutBody = [],
  button_alignment: buttonAlignment
}) => {
  const [copySuccess, setCopySuccess] = useState<TranslationTag>();
  const { userWebId } = useSelector(select.session.get);
  const userWebIdCookie = cookies.get(CookieNames.WEB_ID);
  const webId = userWebId || userWebIdCookie;
  const isMobile = useSelector(select.device.isMobile);
  const { modal } = useDispatch<Dispatch>();
  const openLoginModal = useCallback(() => modal.enqueue({ path: '/auth/login' }), [modal]);
  let body;
  let rafLink = '';

  if (webId) {
    rafLink = new URL(baseUrl).set('query', { source: `RAF_${webId}` }).toString();
    body = loggedInBody.length ? loggedInBody : loggedOutBody;
  } else {
    body = loggedOutBody.length ? loggedOutBody : loggedInBody;
  }

  useEffect(() => {
    if (!webId) {
      setCopySuccess(undefined);
    }
  }, [webId]);

  const copyToClipBoard = async () => {
    try {
      await navigator.clipboard.writeText(rafLink);
      setCopySuccess(TXTCLI_Link_copiedX);
    } catch (err) {
      setCopySuccess(TXTCLI_Failed_to_copy_linkX);
    }
  };

  return (
    <section style={getBackgroundImageStyle(isMobile, backgroundImage?.url)}>
      <div className={styles.widget}>
        {body?.map((item, index) => (
          <CMSReference key={index} {...(item as GlobalFieldReference)} />
        ))}
        <div className={classNames(styles.linkContainer, rafLink && styles.topAlignment)}>
          {rafLink && (
            <p className={styles.label}>
              <Translation {...TXTCLI_Your_referral_link} />
            </p>
          )}
          <div className={classNames(styles.linkRow, buttonAlignment && styles[buttonAlignment])}>
            {rafLink && <p className={styles.generatedLink}>{rafLink}</p>}
            <StarsButton
              className={styles.generateLinkBtn}
              onClick={rafLink ? copyToClipBoard : openLoginModal}
              translation={rafLink ? TXTCLI_Copy_link : TXTCLI_Login}
            />
          </div>
          {copySuccess && (
            <p className={styles.copySuccess}>
              <Translation {...copySuccess} />
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default CMSReferAFriend;
